// extracted by mini-css-extract-plugin
export default {"navItem":"NavItem_navItem__K8JM7","icon":"NavItem_icon__p7KjI","notification":"NavItem_notification__mNebe"};